import React, { useRef } from 'react';
import LibraryDialog from './LibraryDialog';

/**
 * Archiving asks first (PRD-1607). It says the document moves to Archived and
 * can be unarchived, with Cancel and a destructive "Archive document". Focus
 * starts on Cancel, not on the destructive action.
 */
function ArchiveConfirmDialog({ doc, opener, fallbackFocus, onConfirm, onClose }) {
  const cancelRef = useRef(null);
  return (
    <LibraryDialog
      title="Archive document?"
      size="confirm"
      initialFocus={cancelRef}
      opener={opener}
      fallbackFocus={fallbackFocus}
      onClose={onClose}
    >
      <p className="library-dialog-text">{doc.name} moves to Archived. You can unarchive it at any time.</p>
      <div className="library-dialog-actions">
        <button ref={cancelRef} type="button" className="resui-btn resui-btn--secondary" onClick={onClose}>Cancel</button>
        <button type="button" className="resui-btn resui-btn--destructive" onClick={onConfirm}>Archive document</button>
      </div>
    </LibraryDialog>
  );
}

export default ArchiveConfirmDialog;
